// Import variables
import { LOCALSTORAGE_USER } from 'helpers';
import { getI18n } from 'react-i18next';
import { kioskSlug } from 'helpers/common'

export const getHeaders = () => {
	let user = JSON.parse(localStorage.getItem(LOCALSTORAGE_USER)) || null;

	let headers = {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
		Accept: 'application/json',
		platform: 'kiosk',
		'Language': getI18n().language,
		kioskSlug
	};

	if (user) {
		headers['Authorization'] = `Bearer ${user.data.token}`;
	}

	return headers;
};
